<template>
  <div id="SortPanel">
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-sort-down-alt" viewBox="0 0 16 16">
      <path d="M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 12.293V3.5zm4 .5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"/>
    </svg> -->
    <button :disabled="Object.keys(outputs.szafa).length === 0" class="btn btn-sort" @click="zmianaSortowania('symbol')" :class="{active: activeSort === 'symbol'}">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="bi bi-sort-numeric-down">
        <path d="M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"></path>
        <path fill-rule="evenodd" d="M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"></path>
        <path d="M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"></path>
      </svg>
    </button>

    <button :disabled="Object.keys(outputs.szafa).length === 0" class="btn btn-sort" @click="zmianaSortowania('nazwa')" :class="{active: activeSort === 'nazwa'}">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="bi bi-sort-alpha-down">
      <path fill-rule="evenodd" d="M10.082 5.629L9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371h-1.781zm1.57-.785L11 2.687h-.047l-.652 2.157h1.351z"></path>
      <path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V14zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"></path>
      </svg>
    </button>

    <!-- <select :disabled="Object.keys(outputs.szafa).length === 0" class="activity-overview__select" @change="zmianaSortowania()" v-model="selectSort" style="padding: 4px;">
      <option value="symbol">symbol</option>
      <option value="nazwa">nazwa</option>
    </select> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'Koszyk',
  mixins: [app],
  data () {
    return {
      activeSort: 'symbol',
      selectSort: 'symbol',
      searching: '',
      listSearchProduct: []
    }
  },
  computed: {
    ...mapGetters('app', ['inputs', 'outputs']),
    ...mapGetters('products', ['ListaSzafy', 'ListaAkcesoria'])
  },
  methods: {
    sortowanie (val) {
      if (this.activeSort === val) {

      } else {
        this.activeSort = val
        if (this.outputs.szafa.value && this.outputs.szafa.wysokosc_montazowa) {
          this.get_akcesoria(this.outputs.szafa.value, this.outputs.szafa.wysokosc_montazowa, val)
        }
      }
    },
    zmianaSortowania (item) {
      this.selectSort = item
      this.sortowanie(this.selectSort)
    },
    get_akcesoria (kod, wysokosc, sort) {
      this.$store.dispatch('products/load_list_akcesoria', [kod, wysokosc, sort, this.$i18n.locale])
      // console.log(this.produkty_akcesoria)
    }
  }
}
</script>

<style scoped>
#SortPanel {
float: right;
}

.btn-sort {
  padding: 2px 8px;
  border: 2px solid #d8d8d8;
}
.btn-sort:hover {
  background-color: #00c3ff !important;
    color: #fff !important;
  border: 2px solid #fff;
}
.active {
    /* color: #000;
    background-color: #00c3ff;
    border-color: #00c3ff; */
    color: #00c3ff !important;
    background-color: #fff !important;
    border: 2px solid #00c3ff !important;
}
.active:hover {
    /* color: #000;
    background-color: #00c3ff;
    border-color: #00c3ff; */
    color: #00c3ff !important;
    background-color: #fff !important;
    border: 2px solid #00c3ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/SortPanel.vue